import { clone } from 'lodash';
import { Component, Vue, Prop as prop, Watch as watch } from 'nuxt-property-decorator';

@Component({
    components: {
        materialSelector: require('~/components/form/material-selector').default
    }
})
export default class OfferRefSelectorComponent extends Vue {
    @prop()
    private options!: OfferRefOptionContainer;

    @prop()
    private value!: number;

    @prop()
    private selectedOffer!: OfferRefInfo;

    public params: {[key: string]: string} = null;

    created() {
        this.onOfferUpdate();
    }

    updateOptions(value: string | null, options: OfferRefOptionContainer) {
        if (value) {
            Vue.set(this.params, options.key, value);
        } else {
            if (!options.options.find((el) => el.value === this.params[options.key])) {
                Vue.set(this.params, options.key, options.options[0].value);
            }
            value = this.params[options.key];
        }

        const selectedOption = options.options.find((el) => el.value === value);
        console.log(value, selectedOption.targetOffer, this.value, options.key)

        if (selectedOption.childs) {
            this.updateOptions(null, selectedOption.childs);
        } else  if (selectedOption.targetOffer !== this.value) {
            this.$emit('input', selectedOption.targetOffer);
        }
    }

    get displayList() {
        return this.getOptions(this.options);
    }

    private getOptions(options: OfferRefOptionContainer) {
        const result = [options];

        const selectedOption = options.options.find(el => el.childs && el.value === this.params[options.key]);

        if (selectedOption) {
            return result.concat(this.getOptions(selectedOption.childs));
        }

        return result;
    }

    @watch('selectedOffer')
    onOfferUpdate() {
        this.params = clone(this.selectedOffer.keys);
    }
}
